
export const CAPTCHA = {
  NAMESPACE: 'captcha',
  ACTIONS: {
    GET_CAPTCHA_IMAGE: 'getCaptchaImage',
    GET_CAPTCHA_METHOD: 'getCaptchaMethod',
    CLEAR_CAPTCHA_IMAGE: 'clearCaptchaImage',
    CLEAR_CAPTCHA_METHOD: 'clearCaptchaMethod'
  },
  MUTATIONS: {
    GET_CAPTCHA_IMAGE: 'getCaptchaImage',
    GET_CAPTCHA_METHOD: 'getCaptchaMethod',
    CLEAR_CAPTCHA_IMAGE: 'clearCaptchaImage',
    CLEAR_CAPTCHA_METHOD: 'clearCaptchaMethod'
  },
  STATE: {
    IMAGE: 'image',
    CAPTCHA_ID: 'captchaId',
    METHOD: 'method'
  }
}

export const INCOTERMS_MANAGEMENT = {
  NAMESPACE: 'incotermsManagement',
  ACTIONS: {
    GET_INCOTERMS: 'getIncoterms',
    EDIT_INCOTERM: 'editIncoterm',
    DELETE_INCOTERM: 'deleteIncoterm',
    ADD_INCOTERM: 'addIncoterm',
    CLEAR_INCOTERMS: 'clearIncoterms'
  },
  MUTATIONS: {
    GET_INCOTERMS: 'getIncoterms',
    CLEAR_INCOTERMS: 'clearIncoterms'
  },
  STATE: {
    INCOTERMS: 'currencies'
  }
}
export const PREPAYMENT_SETTINGS_MANAGEMENT = {
  NAMESPACE: 'prepaymentSettingsManagement',
  ACTIONS: {
    GET_PREPAYMENT_SETTINGS: 'getPrepaymentSettings',
    EDIT_PREPAYMENT_SETTING: 'editPrepaymentSetting',
    GET_ORGANIZATION_PREPAYMENT_SETTING: 'getOrganizationPrepaymentSetting',
    CLEAR_ORGANIZATION_PREPAYMENT_SETTING: 'clearOrganizationPrepaymentSetting',
    CLEAR_PREPAYMENT_SETTINGS: 'clearPrepaymentSettings'
  },
  MUTATIONS: {
    GET_PREPAYMENT_SETTINGS: 'getPrepaymentSettings',
    GET_ORGANIZATION_PREPAYMENT_SETTING: 'getOrganizationPrepaymentSetting',
    CLEAR_ORGANIZATION_PREPAYMENT_SETTING: 'clearOrganizationPrepaymentSetting',
    CLEAR_PREPAYMENT_SETTINGS: 'clearPrepaymentSettings'
  },
  STATE: {
    PREPAYMENT_SETTINGS: 'prepaymentSettings',
    CURRENT_PREPAYMENT_SETTINGS: 'currentPrepaymentSettings'
  }
}
export const DELIVERY_BASISES_MANAGEMENT = {
  NAMESPACE: 'deliveryBasisesManagement',
  ACTIONS: {
    GET_DELIVERY_BASISES: 'deliveryBasises',
    EDIT_DELIVERY_BASIS: 'editDeliveryBasis',
    ADD_DELIVERY_BASIS: 'addDeliveryBasis',
    DELETE_DELIVERY_BASIS: 'deleteDeliveryBasis',
    CLEAR_DELIVERY_BASISES: 'clearDeliveryBasises',
    CLEAR_DELIVERY_BASIS_INFO: 'clearDeliveryBasisInfo'
  },
  MUTATIONS: {
    GET_DELIVERY_BASISES: 'getDeliveryBasises',
    CLEAR_DELIVERY_BASISES: 'clearDeliveryBasises'
  },
  STATE: {
    DELIVERY_BASISES: 'deliveryBasises'
  }
}
export const CURRENT_ORGANIZATION = {
  NAMESPACE: 'currentOrganization',
  ACTIONS: {
    GET_CURRENT_ORGANIZATION: 'getCurrentOrganization',
    GET_REGISTRATION_CARD: 'getRegistrationCard',
    CLEAR_CURRENT_ORGANIZATION: 'clearCurrentOrganization'
  },
  MUTATIONS: {
    GET_CURRENT_ORGANIZATION: 'getCurrentOrganization',
    CLEAR_CURRENT_ORGANIZATION: 'clearCurrentOrganization'
  },
  STATE: {
    ORGANIZATION: 'organization'
  }
}
export const ORGANIZATION_DRAFT = {
  NAMESPACE: 'organizationDraft',
  ACTIONS: {
    MERGE_FIELDS: 'mergeFields',
    GET_ORGANIZATION_DRAFT: 'getOrganizationDraft',
    CREATE_ORGANIZATION_DRAFT: 'createOrganizationDraft',
    UPDATE_ORGANIZATION_DRAFT: 'updateOrganizationDraft',
    GET_ORGANIZATION_REGISTRATION_REQUEST: 'getOrganizationRegistrationRequest',
    SEND_ORGANIZATION_REGISTRATION_REQUEST: 'sendOrganizationRegistrationRequest',
    GET_REGISTRATION_CARD: 'getRegistrationCard',
    CLEAR_ORGANIZATION_DRAFT: 'clearOrganizationDraft',
    CLEAR_ORGANIZATION_REGISTRATION_REQUEST: 'clearOrganizationRegistrationRequest'
  },
  MUTATIONS: {
    DRAFT_CHANGED: 'draftChanged',
    MERGE_FIELDS: 'mergeFields',
    CLEAR_ORGANIZATION_DRAFT: 'clearOrganizationDraft',
    GET_ORGANIZATION_REGISTRATION_REQUEST: 'getOrganizationRegistrationRequest',
    CLEAR_ORGANIZATION_REGISTRATION_REQUEST: 'clearOrganizationRegistrationRequest'
  },
  STATE: {
    DRAFT_CHANGED: 'draftChanged',
    DRAFT: 'draft',
    REQUEST: 'request'
  }
}
export const ACCOUNT = {
  NAMESPACE: 'account',
  ACTIONS: {
    REGISTER_USER: 'registerUser',
    LOG_IN_USER: 'logInUser',
    LOG_IN_ADMIN: 'logInAdmin',
    LOG_IN_DS_USER: 'logInDSUser',
    CHANGE_PASSWORD: 'changePassword',
    SET_USER_NAME: 'setUserName',
    UPDATE_PARTICIPANT_TYPE: 'updateParticipantType',
    RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE: 'reloadLoginStatusFromLocalStorage',
    CONFIRM_EMAIL: 'confirmEmail',
    RESET_PASSWORD: 'resetPassword',
    RESET_PASSWORD_CONFIRMED: 'resetPasswordConfirmed',
    LOG_OUT: 'logOut'
  },
  MUTATIONS: {
    RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE: 'reloadLoginStatusFromLocalStorage',
    LOGIN_ERROR: 'loginError',
    SET_USER_INFO: 'setUserInfo',
    LOGIN_SUCCESS: 'loginSuccess',
    LOG_OUT: 'logOut'
  },
  STATE: {
    IS_LOGGED_IN: 'isLoggedIn',
    TOKEN: 'token',
    PARTICIPANT_TYPE: 'participantType',
    USER_NAME: 'userName'
  }
}
export const CURRENT_USER = {
  NAMESPACE: 'currentUser',
  ACTIONS: {
    GET_CURRENT_USER_INFO: 'getCurrentUserInfo',
    GET_CURRENT_USER_SUBSCRIPTION: 'getCurrentUserSubscription',
    CHANGE_CURRENT_USER_SUBSCRIPTION: 'changeCurrentUserSubscription',
    CLEAR_CURRENT_USER_SUBSCRIPTION: 'clearCurrentUserSubscription',
    CLEAR_CURRENT_USER_INFO: 'clearCurrentUserInfo'
  },
  MUTATIONS: {
    GET_CURRENT_USER_INFO: 'getCurrentUserInfo',
    GET_CURRENT_USER_SUBSCRIPTION: 'getCurrentUserSubscription',
    CLEAR_CURRENT_USER_SUBSCRIPTION: 'clearCurrentUserSubscription',
    CLEAR_CURRENT_USER_INFO: 'clearCurrentUserInfo'
  },
  STATE: {
    EMAIL: 'email',
    PHONE: 'phone',
    HASH: 'hash',
    CONTACT_PERSON: 'contactPerson',
    SUBSCRIPTIONS_STATUS: 'subscriptionsStatus',
    USER_ID: 'userId',
    ORGANIZATION_ID: 'organizationId',
    SUBSCRIPTIONS: 'subscriptions',
    PARTICIPANT_TYPE: 'participantType'
  }
}
export const CURRENT_USER_EXPIRATIONS_DATES = {
  NAMESPACE: 'currentUserExpirationsDates',
  ACTIONS: {
    GET_EXPIRATION_DATES: 'getExpirationDates',
    CLEAR_EXPIRATION_DATES: 'clearExpirationDates'
  },
  MUTATIONS: {
    GET_EXPIRATION_DATES: 'getExpirationDates',
    CLEAR_EXPIRATION_DATES: 'clearExpirationDates'
  },
  STATE: {
    DOCUMENT_EXPIRATION_DATE: 'documentExpirationDate',
    TOTAL_EXPIRATION_DATE: 'totalExpirationDate'
  }
}
export const CURRENT_AUTHORIZATION_DOCUMENTS = {
  NAMESPACE: 'currentAuthorizationDocuments',
  ACTIONS: {
    GET_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST: 'getCurrentUserAuthorizationDocumentList',
    CREATE_USER_AUTHORIZATION_DOCUMENT: 'createUserAuthorizationDocument',
    CLEAR_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST: 'clearCurrentUserAuthorizationDocumentList'
  },
  MUTATIONS: {
    GET_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST: 'getCurrentUserAuthorizationDocumentList',
    CLEAR_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST: 'clearCurrentUserAuthorizationDocumentList'
  },
  STATE: {
    AUTHORIZATION_DOCUMENTS: 'authorizationDocuments'
  }
}
export const USER_PROFILE = {
  NAMESPACE: 'userProfile',
  ACTIONS: {
    GET_USER_PROFILE: 'getUserProfile',
    UPDATE_USER_PROFILE: 'updateUserProfile',
    GET_USER_REGISTRATION_REQUEST: 'getUserRegistrationRequest',
    SEND_USER_REGISTRATION_REQUEST: 'sendUserRegistrationRequest',
    CLEAR_USER_PROFILE: 'clearUserProfile',
    CLEAR_USER_REGISTRATION_REQUEST: 'clearUserRegistrationRequest'
  },
  MUTATIONS: {
    GET_USER_PROFILE: 'getUserProfile',
    MERGE_PROFILE: 'mergeProfile',
    GET_USER_REGISTRATION_REQUEST: 'getUserRegistrationRequest',
    CLEAR_USER_PROFILE: 'clearUserProfile',
    CLEAR_USER_REGISTRATION_REQUEST: 'clearUserRegistrationRequest'
  },
  STATE: {
    USER_PROFILE: 'userProfile',
    REQUEST: 'request'
  }
}
export const DICTIONARIES = {
  NAMESPACE: 'dictionaries',
  ACTIONS: {
    GET_IDENTITY_DICTIONARY_ITEMS: 'getIdentityDictionaryItems',
    GET_BUSINESS_DICTIONARY_ITEMS: 'getBusinessDictionaryItems',
    GET_INCOTERMS_DICTIONARY_ITEMS: 'getIncotermsDictionaryItems',
    GET_DELIVERY_BASISES_DICTIONARY_ITEMS: 'getDeliveryBasisesDictionaryItems',
    CLEAR_DICTIONARY_ITEMS: 'clearDictionaryItems'
  },
  MUTATIONS: {
    GET_DICTIONARY_ITEMS: 'getDictionaryItems',
    CLEAR_DICTIONARY_ITEMS: 'clearDictionaryItems'
  },
  STATE: {
    COUNTRIES: 'countries',
    PRODUCT_SECTIONS: 'productSections',
    INCOTERMS: 'incoterms',
    DELIVERY_BASISES: 'deliveryBasises'

  }
}
export const BUSINESS_FILES = {
  NAMESPACE: 'businessFiles',
  ACTIONS: {
    DOWNLOAD_BUSINESS_FILE: 'downloadBusinessFile',
    UPLOAD_BUSINESS_FILE: 'uploadBusinessFile',
    UPLOAD_SINGLE_BUSINESS_FILE: 'uploadSingleBusinessFile',
    SAVE_FILE_SIGNATURE: 'saveFileSignature',
    ATTACH_FILE_TO_LOT_REQUEST: 'attachFileToLotRequest',
    DELETE_BUSINESS_FILE: 'deleteBusinessFile',
    GET_LOT_REQUEST_FILES: 'getLotRequestFiles',
    GET_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES: 'getLotRequestRequiredDocumentTypes',
    REMOVE_FILE_FROM_ATTACHMENT: 'removeFileFromAttachment',
    CLEAR_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES: 'clearLotRequestRequiredDocumentTypes',
    CLEAR_LOT_REQUEST_FILES: 'clearLotRequestFiles',
    CLEAR_SINGLE_BUSINESS_FILE: 'clearSingleBusinessFile'
  },
  MUTATIONS: {
    ADD_BUSINESS_FILE_TO_STORE_LIST: 'addBusinessFileToStoreList',
    GET_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES: 'getLotRequestRequiredDocumentTypes',
    UPLOAD_SINGLE_BUSINESS_FILE: 'uploadSingleBusinessFile',
    GET_LOT_REQUEST_FILES: 'getLotRequestFiles',
    CLEAR_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES: 'clearLotRequestRequiredDocumentTypes',
    CLEAR_LOT_REQUEST_FILES: 'clearLotRequestFiles',
    CLEAR_SINGLE_BUSINESS_FILE: 'clearSingleBusinessFile'
  },
  STATE: {
    REQUEST_FILES: 'requestFiles',
    REQUIRED_DOCUMENT_TYPES: 'requiredDocumentTypes',
    CURRENT_FILE: 'currentFile'
  }
}
export const GENERAL_FILES = {
  NAMESPACE: 'generalFiles',
  ACTIONS: {
    DOWNLOAD_FILE_WITH_SETTINGS: 'downloadFileWithSettings',
    DOWNLOAD_FILE: 'downloadFile'
  }
}
export const IDENTITY_FILES = {
  NAMESPACE: 'identityFiles',
  ACTIONS: {
    DOWNLOAD_IDENTITY_FILE: 'downloadIdentityFile',
    UPLOAD_IDENTITY_FILE: 'uploadIdentityFile',
    UPLOAD_SINGLE_IDENTITY_FILE: 'uploadSingleIdentityFile',
    DELETE_IDENTITY_FILE: 'deleteIdentityFile',
    GET_REQUEST_FILES: 'getRequestFiles',
    LINK_REQUEST_FILE: 'linkRequestFile',
    GET_REQUIRED_DOCUMENT_TYPES: 'getRequiredDocumentTypes',
    EDIT_REQUEST_FILE_METADATA: 'editRequestFileMetadata',
    CLEAR_REQUIRED_DOCUMENT_TYPES: 'clearRequiredDocumentTypes',
    CLEAR_REQUEST_FILES: 'clearRequestFiles',
    CLEAR_SINGLE_IDENTITY_FILE: 'clearSingleIdentityFile'
  },
  MUTATIONS: {
    ADD_FILE_TO_STORE_LIST: 'addFileToStoreList',
    DELETE_FILE_FROM_STORE_LIST: 'deleteFileFromStoreList',
    EDIT_REQUEST_FILE_METADATA: 'editRequestFileMetadata',
    GET_REQUIRED_DOCUMENT_TYPES: 'getRequiredDocumentTypes',
    UPLOAD_SINGLE_IDENTITY_FILE: 'uploadSingleIdentityFile',
    GET_REQUEST_FILES: 'getRequestFiles',
    CLEAR_REQUIRED_DOCUMENT_TYPES: 'clearRequiredDocumentTypes',
    CLEAR_REQUEST_FILES: 'clearRequestFiles',
    CLEAR_SINGLE_IDENTITY_FILE: 'clearSingleIdentityFile'
  },
  STATE: {
    REQUEST_FILES: 'requestFiles',
    REQUIRED_DOCUMENT_TYPES: 'requiredDocumentTypes',
    CURRENT_FILE: 'currentFile'
  }
}
export const AXIOS_REQUESTS = {
  NAMESPACE: 'axiosRequests',
  ACTIONS: {
    GET_AXIOS_REQUEST: 'getAxiosRequest',
    PUT_AXIOS_REQUEST: 'putAxiosRequest',
    POST_AXIOS_REQUEST: 'postAxiosRequest',
    DELETE_AXIOS_REQUEST: 'deleteAxiosRequest'
  }
}
export const ERRORS = {
  NAMESPACE: 'errors',
  ACTIONS: {
    SHOW_ERROR: 'showError',
    SHOW_AND_THROW_ERROR: 'showAndThrowError',
    HIDE_ERROR: 'hideError'
  },
  MUTATIONS: {
    ERROR_RECEIVED: 'errorReceived',
    ERROR_CLEAR: 'errorClear'
  },
  STATE: {
    GENERAL_ERROR: 'generalError'
  }
}
export const LOG_MANAGEMENT = {
  NAMESPACE: 'logManagement',
  ACTIONS: {
    GET_LOG: 'getLog',
    CLEAR: 'clear'
  },
  MUTATIONS: {
    GET_LOG: 'getLog',
    CLEAR: 'clear'
  },
  STATE: {
    LOGS: 'logs'
  }
}
export const LOT_CLARIFICATIONS_MANAGEMENT = {
  NAMESPACE: 'lotClarificationsManagement',
  ACTIONS: {
    GET_CLARIFICATIONS_LIST: 'getClarificationsList',
    GET_CLARIFICATION_INFO: 'getClarificationInfo',
    CREATE_CLARIFICATION: 'createClarification',
    UPDATE_CLARIFICATION: 'updateClarification',
    DELETE_CLARIFICATION: 'deleteClarification',
    CLEAR_CLARIFICATION_INFO: 'clearClarificationInfo',
    CLEAR_CLARIFICATIONS_LIST: 'clearClarificationsList'
  },
  MUTATIONS: {
    GET_CLARIFICATION_INFO: 'getClarificationInfo',
    GET_CLARIFICATIONS_LIST: 'getClarificationsList',
    CLEAR_CLARIFICATION_INFO: 'clearClarificationInfo',
    CLEAR_CLARIFICATIONS_LIST: 'clearClarificationsList'
  },
  STATE: {
    CLARIFICATIONS: 'clarifications',
    CURRENT_CLARIFICATION: 'currentClarification'
  }
}
export const LOT_DOCUMENTATION = {
  NAMESPACE: 'lotDocumentation',
  ACTIONS: {
    GET_LOT_DOCUMENTATION: 'getLotDocumentation',
    GET_TRADE_PROCESS_DOCUMENTATION: 'getTradeProcessDocumentation',
    GET_TRADE_PROCESS_DOCUMENTATION_SIGNERS: 'getTradeProcessDocumentationSigners',
    GET_TRADE_DOCUMENT_TYPES: 'getTradeDocumentTypes',
    DELETE_TRADE_PROCESS_DOCUMENTATION: 'deleteTradeProcessDocumentation',
    ADD_TRADE_PROCESS_DOCUMENT: 'addTradeProcessDocument',
    CLEAR_LOT_DOCUMENTATION: 'clearLotDocumentation',
    CLEAR_TRADE_PROCESS_DOCUMENTATION: 'clearTradeProcessDocumentation',
    CLEAR_TRADE_PROCESS_DOCUMENTATION_SIGNERS: 'clearTradeProcessDocumentationSigners',
    CLEAR_TRADE_DOCUMENT_TYPES: 'clearTradeDocumentTypes'
  },
  MUTATIONS: {
    GET_LOT_DOCUMENTATION: 'getLotDocumentation',
    GET_TRADE_PROCESS_DOCUMENTATION: 'getTradeProcessDocumentation',
    GET_TRADE_PROCESS_DOCUMENTATION_SIGNERS: 'getTradeProcessDocumentationSigners',
    CLEAR_TRADE_PROCESS_DOCUMENTATION_SIGNERS: 'clearTradeProcessDocumentationSigners',
    GET_TRADE_DOCUMENT_TYPES: 'getTradeDocumentTypes',
    CLEAR_LOT_DOCUMENTATION: 'clearLotDocumentation',
    CLEAR_TRADE_PROCESS_DOCUMENTATION: 'clearTradeProcessDocumentation',
    CLEAR_TRADE_DOCUMENT_TYPES: 'clearTradeDocumentTypes'
  },
  STATE: {
    LOT_DOCUMENTATION: 'lotDocumentation',
    TRADE_PROCESS_DOCUMENTATION: 'tradeProcessDocumentation',
    DOCUMENT_SIGNERS_INFO: 'documentSignersInfo',
    TRADE_DOCUMENT_TYPES: 'tradeDocumentTypes'
  }
}
export const LOT_DOCUMENT_GENERATOR = {
  NAMESPACE: 'lotDocumentGenerator',
  ACTIONS: {
    GET_GENERATED_FILE_FOR_LOT: 'getGeneratedFileForLot',
    GET_LOT_PROTOCOL: 'getLotProtocol',
    ATTACH_LOT_PROTOCOL: 'attachLotProtocol',
    GET_LOT_OFFERS_REGISTRY: 'getLotOffersRegistry',
    ATTACH_LOT_OFFERS_REGISTRY: 'attachLotOffersRegistry'
  }
}
export const LOT_MANAGEMENT = {
  NAMESPACE: 'lotManagement',
  ACTIONS: {
    GET_LOT_INFO: 'getLotInfo',
    CREATE_LOT_INFO: 'createLotInfo',
    UPDATE_LOT_INFO: 'updateLotInfo',
    DELETE_LOT: 'deleteLot',
    CLEAR_LOT_INFO: 'clearLotInfo'
  },
  MUTATIONS: {
    GET_LOT_INFO: 'getLotInfo',
    CLEAR_LOT_INFO: 'clearLotInfo'
  },
  STATE: {
    CURRENT_LOT: 'currentLot'
  }
}
export const LOT_ORDERS = {
  NAMESPACE: 'lotOrders',
  ACTIONS: {
    GET_ORDERS_LIST: 'getOrdersList',
    GET_ORDER: 'getOrder',
    GET_TRADE_RESULTS_LIST: 'getTradeResultsList',
    GET_TRADE_RESULTS_ORGANIZATIONS: 'getTradeResultsOrganizations',
    ADD_ORDER: 'addOrder',
    CHANGE_ORDER_STATUS: 'changeOrderStatus',
    CLEAR_ORDERS_LIST: 'clearOrdersList',
    CLEAR_ORDER: 'clearOrder',
    CLEAR_TRADE_RESULTS_LIST: 'clearTradeResultsList',
    CLEAR_TRADE_RESULTS_ORGANIZATIONS: 'clearTradeResultsOrganizations'
  },
  MUTATIONS: {
    GET_ORDERS_LIST: 'getOrdersList',
    GET_ORDER: 'getOrder',
    GET_TRADE_RESULTS_LIST: 'getTradeResultsList',
    GET_TRADE_RESULTS_ORGANIZATIONS: 'getTradeResultsOrganizations',
    CLEAR_ORDERS_LIST: 'clearOrdersList',
    CLEAR_ORDER: 'clearOrder',
    CLEAR_TRADE_RESULTS_LIST: 'clearTradeResultsList',
    CLEAR_TRADE_RESULTS_ORGANIZATIONS: 'clearTradeResultsOrganizations'
  },
  STATE: {
    ORDERS: 'orders',
    LAST_ORDER: 'lastOrder',
    TRADE_RESULTS: 'tradeResults',
    TRADE_RESULTS_ORGANIZATIONS: 'tradeResultsOrganizations'
  }
}
export const LOT_POSITIONS_MANAGEMENT = {
  NAMESPACE: 'lotPositionsManagement',
  ACTIONS: {
    GET_POSITIONS_LIST: 'getPositionsList',
    GET_POSITION_INFO: 'getPositionInfo',
    CREATE_POSITION: 'createPosition',
    UPDATE_POSITION: 'updatePosition',
    DELETE_POSITION: 'deletePosition',
    CLEAR_POSITION_INFO: 'clearPositionInfo',
    CLEAR_POSITIONS_LIST: 'clearPositionsList'
  },
  MUTATIONS: {
    GET_POSITION_INFO: 'getPositionInfo',
    GET_POSITIONS_LIST: 'getPositionsList',
    CLEAR_POSITION_INFO: 'clearPositionInfo',
    CLEAR_POSITIONS_LIST: 'clearPositionsList'
  },
  STATE: {
    POSITIONS: 'positions',
    CURRENT_POSITION: 'currentPosition'
  }
}
export const LOT_REQUESTS_MANAGEMENT = {
  NAMESPACE: 'lotRequestsManagement',
  ACTIONS: {
    GET_LOT_REQUESTS: 'getLotRequests',
    GET_LOT_REQUEST_INFO: 'getLotRequestInfo',
    GET_LAST_LOT_REQUEST_INFO: 'getLastLotRequestInfo',
    CREATE_LOT_REQUEST: 'createLotRequest',
    CLEAR_LOT_REQUEST_INFO: 'clearLotRequestInfo',
    CLEAR_LOT_REQUESTS: 'clearLotRequests',
    CLEAR_LAST_LOT_REQUEST_INFO: 'clearLastLotRequestInfo'
  },
  MUTATIONS: {
    GET_LOT_REQUEST_INFO: 'getLotRequestInfo',
    GET_LOT_REQUESTS: 'getLotRequests',
    GET_LAST_LOT_REQUEST_INFO: 'getLastLotRequestInfo',
    CLEAR_LOT_REQUEST_INFO: 'clearLotRequestInfo',
    CLEAR_LOT_REQUESTS: 'clearLotRequests',
    CLEAR_LAST_LOT_REQUEST_INFO: 'clearLastLotRequestInfo'
  },
  STATE: {
    REQUESTS: 'requests',
    CURRENT_REQUEST: 'currentRequest',
    LAST: 'last'
  }
}
export const LOTS = {
  NAMESPACE: 'lots',
  ACTIONS: {
    GET_LOTS_LIST: 'getLotsList',
    GET_LOT_ACTIONS: 'getLotActions',
    CLEAR_LOTS_LIST: 'clearLotsList',
    CLEAR_LOT_ACTIONS: 'clearLotActions'
  },
  MUTATIONS: {
    GET_LOTS_LIST: 'getLotsList',
    GET_LOT_ACTIONS: 'getLotActions',
    CLEAR_LOTS_LIST: 'clearLotsList',
    CLEAR_LOT_ACTIONS: 'clearLotActions'
  },
  STATE: {
    LIST: 'list',
    ACTIONS: 'actions'
  },
  GETTERS: {
    ACTIONS_BY_LOT_ID: 'actionsByLotId'
  }
}
export const LOT_SESSIONS_MANAGEMENT = {
  NAMESPACE: 'lotSessionsManagement',
  ACTIONS: {
    GET_SESSIONS_LIST: 'getSessionsList',
    GET_SESSION_INFO: 'getSessionInfo',
    GET_TEMPLATE_SESSION_INFO: 'getTemplateSessionInfo',
    CREATE_SESSION: 'createSession',
    UPDATE_SESSION: 'updateSession',
    DELETE_SESSION: 'deleteSession',
    CLEAR_SESSION_INFO: 'clearSessionInfo',
    CLEAR_SESSIONS_LIST: 'clearSessionsList',
    CLEAR_TEMPLATE_SESSION_INFO: 'clearTemplateSessionInfo'
  },
  MUTATIONS: {
    GET_SESSION_INFO: 'getSessionInfo',
    GET_TEMPLATE_SESSION_INFO: 'getTemplateSessionInfo',
    GET_SESSIONS_LIST: 'getSessionsList',
    CLEAR_SESSION_INFO: 'clearSessionInfo',
    CLEAR_TEMPLATE_SESSION_INFO: 'clearTemplateSessionInfo',
    CLEAR_SESSIONS_LIST: 'clearSessionsList'
  },
  STATE: {
    SESSIONS: 'sessions',
    CURRENT_SESSION: 'currentSession',
    TEMPLATE_SESSION: 'templateSession'
  }
}
export const LOT_WINNERS_MANAGEMENT = {
  NAMESPACE: 'lotWinnersManagement',
  ACTIONS: {
    GET_WINNER_SELECTION_LIST: 'getWinnerSelectionList',
    SELECT_WINNERS: 'selectWinners',
    UPDATE_WINNERS: 'updateWinners',
    CLEAR_WINNER_SELECTION_LIST: 'clearWinnerSelectionList'
  },
  MUTATIONS: {
    GET_WINNER_SELECTION_LIST: 'getWinnerSelectionList',
    CLEAR_WINNER_SELECTION_LIST: 'clearWinnerSelectionList'
  },
  STATE: {
    WINNER_SELECTION_LIST: 'winnerSelectionList'
  }
}
export const SESSIONS_MANAGEMENT = {
  NAMESPACE: 'sessionsManagement',
  ACTIONS: {
    GET_ACTIVE_SESSIONS: 'getActiveSessions',
    CLEAR_ACTIVE_SESSIONS: 'clearActiveSessions'
  },
  MUTATIONS: {
    GET_ACTIVE_SESSIONS: 'getActiveSessions',
    CLEAR_ACTIVE_SESSIONS: 'clearActiveSessions'
  },
  STATE: {
    ACTIVE: 'active'
  }
}
export const MAILING = {
  NAMESPACE: 'mailing',
  ACTIONS: {
    SEND_GLOBAL_MAILING: 'sendGlobalMailing',
    SEND_PARTICIPANTS_MAILING: 'sendParticipantsMailing',
    SEND_OFFERER_NOTIFICATION: 'sendOffererNotification',
    GET_MAILING_LISTS: 'getMailingLists',
    EDIT_MAILING_LIST_ITEM: 'editMailingListItem',
    CLEAR_MAILING_LISTS: 'clearMailingLists'
  },
  MUTATIONS: {
    GET_MAILING_LISTS: 'getMailingLists',
    CLEAR_MAILING_LISTS: 'clearMailingLists'
  },
  STATE: {
    MAILING_LISTS: 'mailingLists'
  }
}
export const FUNDS_MANAGEMENT = {
  NAMESPACE: 'fundsManagement',
  ACTIONS: {
    GET_LOTS_FUNDS: 'getLotsFunds',
    PERFORM_FUNDS_ACTION: 'performFundsAction',
    CLEAR_LOTS_FUNDS: 'clearLotsFunds'
  },
  MUTATIONS: {
    GET_LOTS_FUNDS: 'getLotsFunds',
    CLEAR_LOTS_FUNDS: 'clearLotsFunds'
  },
  STATE: {
    LOT_FUNDS: 'lotFunds'
  }
}
export const ORGANIZATION_MANAGEMENT = {
  NAMESPACE: 'organizationManagement',
  ACTIONS: {
    MERGE_FIELDS: 'mergeFields',
    GET_ORGANIZATIONS_LIST: 'getOrganizationsList',
    GET_ORGANIZATIONS_SHORT_INFO_LIST: 'getOrganizationsShortInfoList',
    GET_ORGANIZATION_USERS: 'getOrganizationUsers',
    GET_ORGANIZATION_ADMIN: 'getOrganizationAdmin',
    GET_ORGANIZATION_EDIT_INFO: 'getOrganizationEditInfo',
    GET_REGISTRATION_CARD: 'getRegistrationCard',
    UPDATE_ORGANIZATION: 'updateOrganization',
    SEND_TO_CRM: 'sendToCRM',
    SEND_NOTIFICATION_OF_ORGANIZATION_ACCEPTANCE: 'sendNotificationOfOrganizationAcceptance',
    CHANGE_ORGANIZATION_LOCK_STATUS: 'changeOrganizationLockStatus',
    CLEAR_ORGANIZATIONS_LIST: 'clearOrganizationsList',
    CLEAR_ORGANIZATIONS_SHORT_INFO_LIST: 'clearOrganizationsShortInfoList',
    CLEAR_ORGANIZATION_ADMIN: 'clearOrganizationAdmin',
    CLEAR_ORGANIZATION_EDIT_INFO: 'clearOrganizationEditInfo',
    CLEAR_ORGANIZATION_USERS: 'clearOrganizationUsers',
    CLEAR_ORGANIZATION_INFO: 'clearOrganizationInfo'
  },
  MUTATIONS: {
    ORGANIZATION_CHANGED: 'organizationChanged',
    MERGE_FIELDS: 'mergeFields',
    GET_ORGANIZATION_EDIT_INFO: 'getOrganizationEditInfo',
    GET_ORGANIZATIONS_LIST: 'getOrganizationsList',
    GET_ORGANIZATIONS_SHORT_INFO_LIST: 'getOrganizationsShortInfoList',
    SET_SHORT_INFO_LIST_LOADING: 'setShortInfoListLoading',
    GET_ORGANIZATION_USERS: 'getOrganizationUsers',
    CLEAR_ORGANIZATIONS_LIST: 'clearOrganizationsList',
    CLEAR_ORGANIZATIONS_SHORT_INFO_LIST: 'clearOrganizationsShortInfoList',
    GET_ORGANIZATION_ADMIN: 'getOrganizationAdmin',
    CLEAR_ORGANIZATION_INFO: 'clearOrganizationInfo',
    CLEAR_ORGANIZATION_ADMIN: 'clearOrganizationAdmin',
    CLEAR_ORGANIZATION_EDIT_INFO: 'clearOrganizationEditInfo',
    CLEAR_ORGANIZATION_USERS: 'clearOrganizationUsers'
  },
  STATE: {
    USERS: 'users',
    ORGANIZATIONS: 'organizations',
    CURRENT_ORGANIZATION: 'currentOrganization',
    SHORT_INFO_LIST: 'shortInfoList',
    SHORT_INFO_LIST_LOADING: 'shortInfoListLoading',
    ORGANIZATION_INFO: 'organizationInfo',
    ORGANIZATION_CHANGED: 'organizationChanged',
    ORGANIZATION_EDIT_INFO: 'organizationEditInfo'
  }
}
export const ORGANIZATION_DRAFTS_MANAGEMENT = {
  NAMESPACE: 'organizationDraftsManagement',
  ACTIONS: {
    MERGE_FIELDS: 'mergeFields',
    GET_ORGANIZATION_DRAFT: 'getOrganizationDraft',
    CREATE_ORGANIZATION_DRAFT: 'createOrganizationDraft',
    UPDATE_ORGANIZATION_DRAFT: 'updateOrganizationDraft',
    SEND_ORGANIZATION_REGISTRATION_REQUEST: 'sendOrganizationRegistrationRequest',
    GET_ORGANIZATION_REGISTRATION_REQUEST: 'getOrganizationRegistrationRequest',
    GET_REGISTRATION_CARD: 'getRegistrationCard',
    CLEAR_ORGANIZATION_DRAFT: 'clearOrganizationDraft',
    CLEAR_ORGANIZATION_REGISTRATION_REQUEST: 'clearOrganizationRegistrationRequest'
  },
  MUTATIONS: {
    DRAFT_CHANGED: 'draftChanged',
    MERGE_FIELDS: 'mergeFields',
    CLEAR_ORGANIZATION_DRAFT: 'clearOrganizationDraft',
    GET_ORGANIZATION_REGISTRATION_REQUEST: 'getOrganizationRegistrationRequest',
    CLEAR_ORGANIZATION_REGISTRATION_REQUEST: 'clearOrganizationRegistrationRequest'
  },
  STATE: {
    DRAFT_CHANGED: 'draftChanged',
    DRAFT: 'draft',
    REQUEST: 'request'
  }
}
export const AUTHORIZATION_DOCUMENTS_MANAGEMENT = {
  NAMESPACE: 'authorizationDocumentsManagement',
  ACTIONS: {
    GET_AUTHORIZATION_DOCUMENTS_LIST_ADMIN: 'getAuthorizationDocumentsListAdmin',
    GET_AUTHORIZATION_DOCUMENT_ADMIN: 'getAuthorizationDocumentAdmin',
    CHANGE_AUTHORIZATION_DOCUMENT_STATUS: 'changeAuthorizationDocumentStatus',
    UPDATE_AUTHORIZATION_DOCUMENT: 'updateAuthorizationDocument',
    CLEAR_AUTHORIZATION_DOCUMENTS_LIST_ADMIN: 'clearAuthorizationDocumentsListAdmin',
    CLEAR_AUTHORIZATION_DOCUMENT_ADMIN: 'clearAuthorizationDocumentAdmin'
  },
  MUTATIONS: {
    GET_AUTHORIZATION_DOCUMENTS_LIST_ADMIN: 'getAuthorizationDocumentsListAdmin',
    GET_AUTHORIZATION_DOCUMENT_ADMIN: 'getAuthorizationDocumentAdmin',
    CLEAR_AUTHORIZATION_DOCUMENTS_LIST_ADMIN: 'clearAuthorizationDocumentsListAdmin',
    CLEAR_AUTHORIZATION_DOCUMENT_ADMIN: 'clearAuthorizationDocumentAdmin'
  },
  STATE: {
    AUTHORIZATION_DOCUMENTS: 'authorizationDocuments',
    CURRENT_AUTHORIZATION_DOCUMENT: 'currentAuthorizationDocument'
  }
}
export const ORGANIZATION_REQUESTS = {
  NAMESPACE: 'organizationRequests',
  ACTIONS: {
    GET_ORGANIZATION_REGISTRATION_REQUESTS: 'getOrganizationRegistrationRequests',
    GET_ORGANIZATION_REQUEST_INFO: 'getOrganizationRequestInfo',
    PROCESS_ORGANIZATION_REGISTRATION_REQUEST: 'processOrganizationRegistrationRequest',
    CLEAR_ORGANIZATION_REGISTRATION_REQUESTS: 'clearOrganizationRegistrationRequests',
    CLEAR_ORGANIZATION_REQUEST_INFO: 'clearOrganizationRequestInfo'
  },
  MUTATIONS: {
    GET_ORGANIZATION_REGISTRATION_REQUESTS: 'getOrganizationRegistrationRequests',
    GET_ORGANIZATION_REQUEST_INFO: 'getOrganizationRequestInfo',
    CLEAR_ORGANIZATION_REGISTRATION_REQUESTS: 'clearOrganizationRegistrationRequests',
    CLEAR_ORGANIZATION_REQUEST_INFO: 'clearOrganizationRequestInfo'
  },
  STATE: {
    REQUESTS: 'requests',
    CURRENT_REQUEST: 'currentRequest'
  }
}
export const USER_REQUESTS = {
  NAMESPACE: 'userRequests',
  ACTIONS: {
    GET_USER_REGISTRATION_REQUESTS: 'getUserRegistrationRequests',
    GET_USER_REQUEST_INFO: 'getUserRequestInfo',
    PROCESS_USER_REGISTRATION_REQUEST: 'processUserRegistrationRequest',
    CLEAR_USER_REGISTRATION_REQUESTS: 'clearUserRegistrationRequests',
    CLEAR_USER_REQUEST_INFO: 'clearUserRequestInfo'
  },
  MUTATIONS: {
    GET_USER_REGISTRATION_REQUESTS: 'getUserRegistrationRequests',
    GET_USER_REQUEST_INFO: 'getUserRequestInfo',
    CLEAR_USER_REGISTRATION_REQUESTS: 'clearUserRegistrationRequests',
    CLEAR_USER_REQUEST_INFO: 'clearUserRequestInfo'
  },
  STATE: {
    REQUESTS: 'requests',
    CURRENT_REQUEST: 'currentRequest'
  }
}
export const CALENDAR = {
  NAMESPACE: 'calendar',
  ACTIONS: {
    GET_DAY_OFF_DATES: 'getDayOffDates',
    LOAD_PRODUCTION_CALENDAR: 'loadProductionCalendar',
    GET_PRODUCTION_CALENDAR_FILE: 'getProductionCalendarFile'
  },
  MUTATIONS: {
    GET_DAY_OFF_DATES: 'getDayOffDates'
  },
  STATE: {
    DAY_OFF_DAYS: 'dayOffDays'
  }
}
export const LOCALIZATION = {
  NAMESPACE: 'localization',
  ACTIONS: {
    SET_LOCALE: 'setLocale',
    SET_LOCALE_WITHOUT_RELOAD: 'setLocaleWithoutReload',
    REFRESH_LOCALE: 'refreshLocale'
  },
  MUTATIONS: {
    REFRESH_LOCALE: 'refreshLocale'
  },
  STATE: {
    LOCALE: 'locale',
    LOCALES: 'locales'
  }
}
export const RELEVANCE = {
  NAMESPACE: 'relevance',
  ACTIONS: {
    CHECK_RELEVANCE: 'checkRelevance',
    SET_NEED_RELOAD_PAGE: 'setNeedReloadPage'
  },
  MUTATIONS: {
    SET_RELEVANCE: 'setRelevance',
    SET_NEED_RELOAD_PAGE: 'setNeedReloadPage'
  },
  STATE: {
    RELEVANCE: 'relevance',
    NEED_RELOAD_PAGE: 'needReloadPage'
  }
}
export const SYSTEM_SETTINGS = {
  NAMESPACE: 'systemSettings',
  ACTIONS: {
    GET_CONFIGURATION: 'getConfiguration',
    EDIT_SEGMENT_CONFIGURATION: 'editSegmentConfiguration',
    EDIT_CLIENT_THEME: 'editClientTheme',
    RESET_TO_DEFAULT_THEME: 'resetToDefaultTheme',
    CLEAR_CONFIGURATION: 'clearConfiguration',
    CHANGE_TEST_STATUS: 'changeTestStatus',
    GET_ASSEMBLY_VERSIONS: 'getAssemblyVersions',
    GET_SMTP_SETTINGS: 'getSMTPSettings',
    CLEAR_SMTP_SETTINGS: 'clearSMTPSettings',
    EDIT_SMTP_SETTINGS: 'editSMTPSettings',
    GET_TEST_STATUS: 'getTestStatus',
    CHANGE_LOCALIZATION_STATUS: 'changeLocalizationStatus',
    GET_LOCALIZATION_STATUS: 'getLocalizationStatus',
    GET_SERVER_TIME: 'getServerTime',
    CLEAR_SERVER_TIME: 'clearServerTime',
    SETTINGS_IS_LOADED: 'settingsIsLoaded',
    CLEAR_ASSEMBLY_VERSIONS: 'clearAssemblyVersions'
  },
  MUTATIONS: {
    GET_CONFIGURATION: 'getConfiguration',
    CLEAR_CONFIGURATION: 'clearConfiguration',
    GET_TEST_STATUS: 'getTestStatus',
    GET_ASSEMBLY_VERSIONS: 'getAssemblyVersions',
    GET_SMTP_SETTING: 'getSMTPSetting',
    CLEAR_SMTP_SETTING: 'clearSMTPSetting',
    GET_SERVER_TIME: 'getServerTime',
    CLEAR_SERVER_TIME: 'clearServerTime',
    SETTINGS_IS_LOADED: 'settingsIsLoaded',
    CLEAR_ASSEMBLY_VERSIONS: 'clearAssemblyVersions',
    SET_TEST_STATUS: 'setTestStatus',
    GET_LOCALIZATION_STATUS: 'getLocalizationStatus',
    SET_LOCALIZATION_STATUS: 'setLocalizationStatus'
  },
  STATE: {
    CONFIGURATION: 'configuration',
    SMTP_SETTINGS: 'SMTPSettings',
    IS_TEST_MODE: 'isTestMode',
    SERVER_TIME: 'serverTime',
    LOCALIZATION_ENABLED: 'localizationEnabled',
    VERSIONS: 'versions',
    IS_LOADED: 'isLoaded'
  },
  GETTERS: {
    SERVER_TIME: 'serverTime'
  }
}
export const STATIC_PAGES = {
  NAMESPACE: 'staticPages',
  ACTIONS: {
    GET_ALL_STATIC_PAGES: 'getAllStaticPages',
    GET_STATIC_FOLDER_INFO: 'getStaticFolderInfo',
    GET_STATIC_FILES: 'getStaticFiles',
    UPLOAD_STATIC_FILE: 'uploadStaticFile',
    EDIT_STATIC_FILE: 'editStaticFile',
    DELETE_STATIC_FILE: 'deleteStaticFile',
    GET_FULL_PAGE_INFO: 'getFullPageInfo',
    GET_PUBLISHED_PAGE_CONTENT: 'getPublishedPageContent',
    EDIT_PAGE_CONTENT: 'editPageContent',
    EDIT_PAGE: 'editPage',
    DELETE_PAGE: 'deletePage',
    ADD_PAGE: 'addPage',
    ADD_FOLDER: 'addFolder',
    PUBLISH_PAGE_CONTENT: 'publishPageContent',
    RESET_PAGE_CONTENT: 'resetPageContent',
    CLEAR_ALL_STATIC_PAGES: 'clearAllStaticPages',
    CLEAR_FULL_PAGE_INFO: 'clearFullPageInfo',
    CLEAR_PUBLISHED_PAGE_CONTENT: 'clearPublishedPageContent',
    CLEAR_STATIC_FOLDER_INFO: 'clearStaticFolderInfo',
    CLEAR_STATIC_FILES: 'clearStaticFiles'
  },
  MUTATIONS: {
    GET_ALL_STATIC_PAGES: 'getAllStaticPages',
    GET_FULL_PAGE_INFO: 'getFullPageInfo',
    CLEAR_FULL_PAGE_INFO: 'clearFullPageInfo',
    GET_PUBLISHED_PAGE_CONTENT: 'getPublishedPageContent',
    GET_STATIC_FOLDER_INFO: 'getStaticFolderInfo',
    GET_STATIC_FILES: 'GetStaticFiles',
    CLEAR_PUBLISHED_PAGE_CONTENT: 'clearPublishedPageContent',
    CLEAR_STATIC_FOLDER_INFO: 'clearStaticFolderInfo',
    CLEAR_STATIC_FILES: 'clearStaticFiles',
    CLEAR_ALL_STATIC_PAGES: 'clearAllStaticPages'
  },
  STATE: {
    PAGES: 'pages',
    CURRENT_STATIC_PAGE: 'currentStaticPage',
    STATIC_FILES: 'staticFiles',
    CURRENT_STATIC_PAGE_CONTENT: 'currentStaticPageContent',
    STATIC_FOLDER_INFO: 'staticFolderInfo'
  }
}
export const REPORTS = {
  NAMESPACE: 'reports',
  ACTIONS: {
    GET_ORGANIZATIONS_REPORT: 'getOrganizationsReport',
    GET_ORGANIZATIONS_ACTIVITY_REPORT: 'getOrganizationsActivityReport',
    GET_PROTOCOL_SIGNATURES_PIVOT_INFO: 'getProtocolSignaturesPivotInfo',
    CLEAR_PROTOCOL_SIGNATURES_PIVOT_INFO: 'clearProtocolSignaturesPivotInfo'
  },
  MUTATIONS: {
    GET_PROTOCOL_SIGNATURES_PIVOT_INFO: 'getProtocolSignaturesPivotInfo',
    CLEAR_PROTOCOL_SIGNATURES_PIVOT_INFO: 'clearProtocolSignaturesPivotInfo'
  },
  STATE: {
    PROTOCOL_SIGNATURES_PIVOT_INFO: 'protocolSignaturesPivotInfo'
  }
}
export const STATISTICS = {
  NAMESPACE: 'statistics',
  ACTIONS: {
    GET_IDENTITY_STATISTICS: 'getIdentityStatistics',
    CLEAR_IDENTITY_STATISTICS: 'clearIdentityStatistics',
    GET_BUSINESS_STATISTICS: 'getBusinessStatistics',
    CLEAR_BUSINESS_STATISTICS: 'clearBusinessStatistics'
  },
  MUTATIONS: {
    GET_IDENTITY_STATISTICS: 'getIdentityStatistics',
    CLEAR_IDENTITY_STATISTICS: 'clearIdentityStatistics',
    GET_BUSINESS_STATISTICS: 'getBusinessStatistics',
    CLEAR_BUSINESS_STATISTICS: 'clearBusinessStatistics'
  },
  STATE: {
    IDENTITY_STATISTICS: 'identityStatistics',
    BUSINESS_STATISTICS: 'businessStatistics'
  }
}
export const TRADE_REQUEST_MANAGEMENT = {
  NAMESPACE: 'tradeRequestManagement',
  ACTIONS: {
    GET_TRADE_REQUESTS: 'getTradeRequests',
    GET_TRADE_REQUEST_ADMIN: 'getTradeRequestAdmin',
    PROCESS_TRADE_REQUEST: 'processTradeRequest',
    RECALL_LOT: 'recallLot',
    CLEAR_TRADE_REQUESTS: 'clearTradeRequests',
    CLEAR_TRADE_REQUEST_ADMIN: 'clearTradeRequestAdmin'
  },
  MUTATIONS: {
    GET_TRADE_REQUESTS: 'getTradeRequests',
    GET_TRADE_REQUEST_ADMIN: 'getTradeRequestAdmin',
    CLEAR_TRADE_REQUESTS: 'clearTradeRequests',
    CLEAR_TRADE_REQUEST_ADMIN: 'clearTradeRequestAdmin'
  },
  STATE: {
    REQUESTS: 'requests',
    CURRENT_REQUEST: 'currentRequest'
  }
}
export const USER_MANAGEMENT = {
  NAMESPACE: 'userManagement',
  ACTIONS: {
    CREATE_USER: 'createUser',
    MERGE_FIELDS: 'mergeFields',
    FINISH_USER_REGISTRATION: 'finishUserRegistration',
    GET_USERS_LIST: 'getUsersList',
    GET_ALL_ORGANIZERS: 'getAllOrganizers',
    GET_AUTHORIZATION_DOCUMENTS_ADMIN: 'getAuthorizationDocumentsAdmin',
    GET_USER_FOR_ADMIN: 'getUserForAdmin',
    GET_EXPIRATION_DATES: 'getExpirationDates',
    CHANGE_USER_LOCK_STATUS: 'changeUserLockStatus',
    GET_USER_SUBSCRIPTION: 'getUserSubscription',
    CHANGE_USER_SUBSCRIPTION: 'changeUserSubscription',
    UPDATE_USER: 'updateUser',
    UPDATE_USER_EMAIL: 'updateUserEmail',
    UPDATE_EXPIRATION_DATE: 'updateExpirationDate',
    CREATE_AUTHORIZATION_DOCUMENT_ADMIN: 'createAuthorizationDocumentAdmin',
    RESET_CONFIRM_EMAIL: 'resetConfirmEmail',
    CLEAR_USER_FOR_ADMIN: 'clearUserForAdmin',
    CLEAR_ALL_ORGANIZERS: 'clearAllOrganizers',
    CLEAR_USER_SUBSCRIPTION: 'clearUserSubscription',
    CLEAR_USERS_LIST: 'clearUsersList',
    CLEAR_NEW_USER: 'clearNewUser',
    CLEAR_AUTHORIZATION_DOCUMENTS_ADMIN: 'clearAuthorizationDocumentsAdmin',
    CLEAR_EXPIRATION_DATES: 'clearExpirationDates'
  },
  MUTATIONS: {
    MERGE_FIELDS: 'mergeFields',
    USER_CHANGED: 'userChanged',
    GET_USERS_LIST: 'getUsersList',
    GET_ALL_ORGANIZERS: 'getAllOrganizers',
    GET_AUTHORIZATION_DOCUMENTS_ADMIN: 'getAuthorizationDocumentsAdmin',
    GET_USER_FOR_ADMIN: 'getUserForAdmin',
    GET_EXPIRATION_DATES: 'getExpirationDates',
    GET_USER_SUBSCRIPTION: 'getUserSubscription',
    CLEAR_USER_SUBSCRIPTION: 'clearUserSubscription',
    CLEAR_USER_FOR_ADMIN: 'clearUserForAdmin',
    CLEAR_EXPIRATION_DATES: 'clearExpirationDates',
    CLEAR_ALL_ORGANIZERS: 'clearAllOrganizers',
    CLEAR_USERS_LIST: 'clearUsersList',
    CLEAR_NEW_USER: 'clearNewUser',
    CLEAR_AUTHORIZATION_DOCUMENTS_ADMIN: 'clearAuthorizationDocumentsAdmin'
  },
  STATE: {
    USERS: 'users',
    CURRENT_USER: 'currentUser',
    NEW_USER: 'newUser',
    USER_CHANGED: 'userChanged',
    AUTHORIZATION_DOCUMENTS: 'authorizationDocuments',
    SUBSCRIPTIONS: 'subscriptions',
    ORGANIZERS: 'organizers',
    USER_EXPIRATION_DATES: 'userExpirationDates'
  }
}
export const SCHEDULER = {
  NAMESPACE: 'scheduler',
  ACTIONS: {
    SEND_ERRORS_NOTIFICATION: 'sendErrorsNotification',
    SEND_AUTHORIZATION_DOCUMENT_EXPIRATION_DATE_NOTIFICATION: 'sendAuthorizationDocumentExpirationDateNotification',
    SEND_ACTIVITY_STATISTICS_NOTIFICATION: 'sendActivityStatisticsNotification'
  }
}
export const LOT_TEMPLATE_MANAGEMENT = {
  NAMESPACE: 'lotTemplateManagement',
  ACTIONS: {
    GET_LOT_TEMPLATES: 'getLotTemplates',
    CLEAR_LOT_TEMPLATES: 'clearLotTemplates',
    SAVE_AS_TEMPLATE: 'saveAsTemplate',
    GET_LOT_TEMPLATE: 'getLotTemplate',
    CLEAR_LOT_TEMPLATE: 'clearLotTemplate',
    EDIT_LOT_TEMPLATE: 'editLotTemplate',
    DELETE_LOT_TEMPLATE: 'deleteLotTemplate',
    CREATE_LOT_FROM_TEMPLATE: 'createLotFromTemplate',
    CLEAR_LOTID: 'clearLotId'
  },
  MUTATIONS: {
    GET_LOT_TEMPLATES: 'getLotTemplates',
    CLEAR_LOT_TEMPLATES: 'clearLotTemplates',
    GET_LOT_TEMPLATE: 'getLotTemplate',
    CLEAR_LOT_TEMPLATE: 'clearLotTemplate',
    CREATE_LOT_FROM_TEMPLATE: 'createLotFromTemplate',
    CLEAR_LOTID: 'clearLotId'
  },
  STATE: {
    TEMPLATES_LIST: 'templatesList',
    CURRENT_TEMPLATE: 'currentTemplate',
    CREATED_LOT_ID: 'createdLotId'
  }
}

export const POSITIONS_TEMPLATE_MANAGEMENT = {
  NAMESPACE: 'positionsTemplateManagement',
  ACTIONS: {
    GET_POSITION_TEMPLATE_INFO: 'getPositionTemplateInfo',
    GET_POSITION_TEMPLATE_LIST: 'getPositionTemplateList',
    UPDATE_POSITION_TEMPLATE: 'updatePositionTemplate',
    CLEAR_POSITION_TEMPLATE_INFO: 'clearPositionTemplateInfo',
    CLEAR_POSITION_TEMPLATE_LIST: 'clearPositionTemplateList',
    CREATE_POSITION_TEMPLATE: 'createPositionTemplate',
    DELETE_POSITION_TEMPLATE: 'deletePositionTemplate'
  },
  MUTATIONS: {
    GET_POSITION_TEMPLATE_INFO: 'getPositionTemplateInfo',
    GET_POSITION_TEMPLATE_LIST: 'getPositionTemplateList',
    UPDATE_POSITION_TEMPLATE: 'updatePositionTemplate',
    CLEAR_POSITION_TEMPLATE_INFO: 'clearPositionTemplateInfo',
    CLEAR_POSITION_TEMPLATE_LIST: 'clearPositionTemplateList'
  },
  STATE: {
    CURRENT_POSITION_TEMPLATE: 'currentPositionTemplate',
    POSITIONS_TEMPLATE_LIST: 'positionsTemplateList'
  }
}
